import React, { useState, useEffect } from "react";
import FormContainer from "../components/FormContainer";
import { Link, useSearchParams } from "react-router-dom";
import { Alert, Button } from "react-bootstrap";
import { useVerifyEmailMutation } from "../slices/usersApiSlices";
import Loader from "../components/Loader";
import { CiCircleCheck } from "react-icons/ci";
import { useCreateVerifcationLinkMutation } from "../slices/usersApiSlices";



const VerifyEmailScreen = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");

  const [verifyEmail, { isLoadingNewEmail }] = useVerifyEmailMutation();
  const [errorMessage, setErrorMessage] = useState("");
  const [errorCode, setErrorCode] = useState(null)
  const [success, setSuccess] = useState(false);

  const [resendEmailStatus, setResendEmailStatus] = useState("")
  const [createLink, { isLoading }] = useCreateVerifcationLinkMutation();




  useEffect(() => {
    const runVerification = async () => {
      if (!email || !token) {
        setSuccess(false);
        setErrorCode(400)
        setErrorMessage("Verification link is invalid or incomplete.");
        return;
      }

      try {
        await verifyEmail({ email, verificationToken: token }).unwrap();
        setSuccess(true);
        setErrorMessage("");
        setErrorCode(null)
      } catch (err) {
        setSuccess(false);
        setErrorCode(err.status)
        setErrorMessage(err?.data?.message || err?.error || "Could not verify email.");
      }
    };

    runVerification();
  }, [email, token, verifyEmail]);


  const handleSendNewLink = async () => {
    setErrorMessage("");
    setResendEmailStatus("");
    try {
        await createLink({ email }).unwrap();
        setResendEmailStatus("success");
    } catch (err) {
        setResendEmailStatus(err?.data?.message || err?.error || "Could not send, please contact an administrator");
    }
  };



  return (
    <FormContainer>
      <title>Verify Email | ShotArc</title>
      <div className="auth-page-wrap">
        <div className="auth-panel">
          <h1 className="auth-title">Verify Email</h1>
          <p className="auth-subtitle">Confirm your account and continue to your dashboard.</p>

          {isLoading && <Loader />}

          {!isLoading && success && !errorMessage && (
            <div className="d-flex flex-column align-items-center text-center">
              <p className="auth-verify-message mb-2">Your account has been verified.</p>
              <CiCircleCheck color="#22c55e" size="3.5rem" />
              <Link
                to="/LoginScreen"
                className="btn btn-warning text-dark fw-semibold auth-submit-btn mt-3 w-100"
              >
                Login
              </Link>
            </div>
          )}
          {/* Error message   */}
          {!isLoading && !success && errorMessage && (
            <Alert className="app-empty-state app-empty-state--danger mb-0">
              {errorMessage}
            </Alert>
          )}

          {/* Send new link option    */}
          {
          errorCode === 400 &&
          <>
            
            {isLoadingNewEmail && <Loader />}
            {!isLoadingNewEmail && resendEmailStatus === "success" &&
              <p className="auth-verify-message mb-2">A new verification link has been sent to {email}</p>
            }
            {!isLoadingNewEmail && !resendEmailStatus === "success" &&
              <>
              <p className="auth-verify-message text-danger">Could not create link, please contact an administrator</p>
              <p>{resendEmailStatus}</p>
              </>
            }
            <div className="auth-assist-item">  
              <p className="auth-helper-text">Send a new link:</p>
              <Button
                type="button"
                variant="outline-warning"
                className="fw-semibold auth-link-btn auth-register-btn"
                onClick={handleSendNewLink}
              >
                  Send New Link
              </Button>
            </div>
            
          </>
          }




         
        </div>
      </div>
    </FormContainer>
  );
};

export default VerifyEmailScreen;
